__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-host/34201392635/";